export default __webpack_public_path__ + "static/media/personal-loan-bg.29a8ac6c.png";